import { handleActions } from 'redux-actions';
import { defaultAiContentWidgetState } from './defaults';
import { AiContentWidgetData } from './types';
import { initBrowsingPage } from '../../actions';
import {
  makeSpecificSaveableWidgetDataMergeFunction,
  saveRequestMetaReducer,
} from '../utils';
import {
  saveAiContent,
  saveAiContentFailure,
  saveAiContentSuccess,
  setAiContentWidgetShowAi,
} from './actions';
import { NetworkRequestState } from '../baseTypes';

const mergeAiContentWidgetDataChange =
  makeSpecificSaveableWidgetDataMergeFunction(defaultAiContentWidgetState);

export default handleActions<AiContentWidgetData, any>(
  {
    [initBrowsingPage.toString()]: (
      state,
      action: ReturnType<typeof initBrowsingPage>
    ) => {
      const data: AiContentWidgetData['initialData'] = {
        showAi: action.payload.data.showAi,
      };

      return {
        initialData: data,
        currentData: data,
        isDirty: false,
        saveRequest: {
          status: NetworkRequestState.IDLE,
        },
      };
    },
    [setAiContentWidgetShowAi.toString()]: (
      state,
      action: ReturnType<typeof setAiContentWidgetShowAi>
    ) =>
      mergeAiContentWidgetDataChange(state, {
        showAi: action.payload.showAi,
      }),
    ...saveRequestMetaReducer({
      initialAction: saveAiContent,
      successAction: saveAiContentSuccess,
      failureAction: saveAiContentFailure,
    }),
  },
  defaultAiContentWidgetState
);
